import React, { Component } from 'react';
// Images
import Customers from "../../assets/img/CustomersHeb.png";
import Vi from "../../assets/video/PlasticInjection.mp4";
import { isMobile } from 'react-device-detect';
import FaCircle from 'react-icons/lib/fa/circle';


import { Link, Element } from 'react-scroll'
// Animations
import { Animated } from "react-animated-css";
import { scrollUp } from "../functions/functions";
// import {Parallax} from 'react-scroll-parallax';

class Services extends Component {

    async componentDidMount() {
        this.props.changeScrollState(false, 'services')
        await scrollUp()
        await this.scrollEvent()
    }

    scrollEvent() {
        if (!this.props.state.menuScrolled && window.pageYOffset === 0) {
            window.addEventListener('scroll', this.chageParentSate)
        }
    }

    chageParentSate = () => {
        if (window.pageYOffset !== 0) {
            this.props.changeScrollState(true, 'services')
            window.removeEventListener('scroll', this.chageParentSate)
        }
    }

    componentWillUnmount() {
        console.log("unmount")
        this.props.changeScrollState(false, 'services')
    }

    scrollToMyRef = (ref) => ref.current.scrollIntoView({ behavior: 'smooth', block: "nearest", inline: 'nearest' })

    render() {
        return (
            <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>
                <div className="PageHolder">
                    <div className="ContentHolder07">
                        {!isMobile &&
                            <video className="Video01" loop={true} autoPlay>
                                <source src={Vi} type="video/mp4" />
                            </video>
                        }

                        <div className="OnVideo">
                            <div className="ImageHolder05">
                                <img src={Customers} alt="" className="Image02" />

                            </div>
                            <div className="Submenu">
                                <Link className="MenuItem" activeClass="active" to="test3" spy={true} smooth={true} >
                                    <FaCircle size={5} color={'#E75125'} />
                                    עיבוד מתכות
                                </Link>
                                <Link className="MenuItem" activeClass="active" to="test2" spy={true} smooth={true} >
                                    <FaCircle size={5} color={'#E75125'} />

                                    עיבוד שבבי
                                </Link>
                                <Link className="MenuItem" activeClass="active" to="test1" spy={true} smooth={true} >
                                    <FaCircle size={5} color={'#E75125'} />
                                    הזרקת פלסטיק
                                </Link>

                            </div>

                            <div className="ContentHolder08">
                                <div className="FirstContent">
                                    <h1>יחס אישי ורצינות מקצועית</h1>
                                    <p className="rtlText">
                                        במסגרת שנות פעילותינו הרבות, זכינו לשתף פעולה עם מאות לקוחות, מהארץ וממגוון מדינות ברחבי העולם.
                                        אנו, כנותני שירות, מקפידים על התאמה- התאמה שלנו ללקוחותינו ועל התאמה של המוצרים לצרכי הלקוחות שלנו.
                                        זאת לצד, מקצועיות ללא פשרות, ירידה לפרטים הקטנים ביותר, עקביות בטיב המוצר, ייעול הייצור לטובת לקוחותינו ומתן שירות בגובה בעיניים.

                                        תהליך העבודה כולל את אפיון המוצר, בחירת חומר הגלם המתאים ביותר, הקצאת משאבי כוח האדם ומכונות הייצור המותאמים לכל מוצר ולכל לקוח.

                                        בסוף התהליך, מתקבל מוצר מדויק, עקבי באחידותו, אשר משקף בצורה אופטימלית את רצונות ודרישות הלקוח.
                                    </p>
                                    <p className="rtlText">החל מאפיון המוצר , בחירת סוג חומר הגלם , התאמה מרחבית של התבנית  לנפח היצור הנדרש על מנת ליעיל את תהליך היצור ולהוזיל עליות , בנוסף חברתנו מקפידה  על הליך יצור התבנית עצמו  על רמת הדיוק ושימוש בחומר גלם איכותי, כדי להעריך את חיי התבנית, ולדאוג שרמת אחידות המוצרים תהיה גבוה מאד.  </p>
                                </div>
                                <Element name="test1" className="SecondContent">
                                    <h2>הזרקת פלסטיק</h2>
                                    <p className="rtlText">זוהי טכנולוגיה אשר מטרתה - ייצור רכיבים או מוצרים שלמים מפלסטיק באמצעות התכה של חומר הגלם והזרקתו לתבנית. הזרקת פלסטיק, הוא אחד התהליכים הנפוצים ביותר לייצור חלקי פלסטיק במגוון תעשיות:
                                        יכולתנו בקטגוריית מוצרים זו הינה אין-סופית וניתן ליצור כמעט כל צורה העולה בדמיון.
                                        חברת עקיבא טולוצינסקי מתמחה, בין היתר, בפיתוח ובייצור הזרקות פלסטיק ונחשבת לחברה המובילה בישראל בתחום, אשר מצטיינת בתהליכים של פיתוח וייצור באמצעות הזרקת פלסטיק.
                                        חברתינו מספקת שירות היקפי ללקוח, החל מפיתוח ותכנון התבניות ההזרקה וכמובן בפיתוחם ובייצורם של המוצרים.  </p>
                                    <p className="rtlText">
                                        חברתינו מהווה נקודת מפגש אחת ללקוח לאורכו של כל התהליך, אשר משלב גיבוש הקונספט ודרך שלבי הפיתוח, ייצור התבנית, ייצור אב-הטיפוס (כאשר אנו מציעים ללקוחותינו את האפשרות הייחודית לבניית המודלים לפני הפיתוח) וכלה בייצורו ובהרכבתו של המוצר הסופי. כל זה, מאפשר ללקוח ליהנות מאיכות ומאחידותו המוצר ולהנות מיתרונותיהם של הליכי הפיתוח המתקדמים שלנו שכולם כחול-לבן.
                                        אנחנו מלווים כל לקוח שלנו מתחילת דרכו בתהליך התכנון והבנייה של המוצר, ייצור הרכיב כאבטיפוס, ועד לרגע בו התוצאה המוגמרת מונחת בידיו. המקצועיות והניסיון עתיר השנים שלנו מאפשר לנו לייעץ במשך התהליך, ואף לסייע לו בבחירה בין החלופות השונות, אשר ניצבות בפניו.
                                    </p>
                                    <p className="rtlText">
                                        אנחנו מלווים כל לקוח שלנו מתחילת דרכו בתהליך הייצור הרכיב או המוצר העשוי מפלסטיק, ועד לרגע בו התוצאה המוגמרת מונחת בכפות ידיו. המקצועיות והניסיון עתר השנים שלנו מאפשר לנו לייעץ לו במהלך התלבטויותיו, ואף לסייע לו בבחירה בין החלופות השונות, אשר לעיתים ניצבות בפניו.

                                    </p>
                                </Element>
                                <Element name="test2" className="FirstContent">
                                    <h2>עיבוד שבבי לחומרים מרוכבים</h2>
                                    <p className='rtlText'>
                                        עיבוד שבבי, הוא תהליך שבו חומר גלם נחתך לתוך צורה סופית רצויה,
                                        זאת באמצעות הסרת החומר שנדרש באופן מבוקר.
                                        עיבוד שבבי הוא חלק בייצור של מוצרי מתכת רבים, אבל, כמובן יכול להתבצע גם על חומרים כגון עץ, פלסטיק, קרמיקה, פיברגלס, קרבון וחומרים מרוכבים נוספים.
                                        חלק גדול מהעיבוד המודרני מתבצע על ידי מכונת (CNC), שבה מחשבים משמשים לשליטה בתנועה ובהפעלה של טחנות, מחרטות ומכונות חיתוך אחרות.
                                    </p>

                                    <p className='rtlText'>
                                        אנחנו מאמינים כי התפקיד שלנו בתהליך זה הינו במתן ייעוץ והכוונה לדרך הנכונה ביותר לביצוע הדברים, תוך בחינת הנושא דרך עיני הלקוח והקפדה על שמירה על האינטרסים שלו.
                                        תוך כדי חשיבה יצירתית ובמידת הצורך, מציאת פתרונות שאינם שגרתיים.
                                        אנו מעמידים את האמצעים החדישים והמתקדמים ביותר לרשותו של הלקוח.
                                    </p>
                                </Element>
                                <Element name="test3" className="ThirdContent">
                                    <h2>עיבוד מתכות בכבישה קרה/חמה</h2>
                                    <p className='rtlText'>
                                        תהליך הכבישה הוא תהליך עיבוד שבו מעצבים את צורת חומר הגלם באמצעות כוחות לחיצה או מכות לזרימה בכיוונים רצויים .קיימות שתי שיטות מרכזיות לביצוע כבישה - חמה או קרה.
                                        בכבישה החמה, משתמשים בחימום חומר הגלם לטמפרטורות מאוד גבוהה כזאת המאפשרת לחומר דינמיות מירבית.
                                        ברוב המקרים, עם זאת, משתמשים בכבישה הקרה, שנעשית בטמפרטורת החדר.
                                    </p>
                                    <p className='rtlText'>
                                        אנחנו, בחברת עקיבא טולוצ'ינסקי, מעניקים גם בתחום זה שירות ומענה מקצועי מלא,
                                        ובו התאמה של חומר הגלם הנכון למוצר, סוג הכבישה המומלצת וזאת מזווית עינו של הלקוח ושמירה על המטרות והיעדים שהוגדרו על ידו בתחילת התהליך.
                                    </p>
                                </Element>
                            </div>

                        </div>
                    </div>



                </div>
            </Animated>
        );
    }
}

export default Services;



// WEBPACK FOOTER //
// ./src/components/pages/Services.js